export const contactSupport = {
  support_title_message: "¡Contáctanos y  resolveremos juntos!",
  support_message: "¿Alguna duda? Escríbenos por WhatsApp o correo. Estamos para ayudarte.",
  support_modal_email: "Correo electrónico",
};
